import { useContext, useEffect, useReducer, useState,useRef } from "react";
import { Contexto } from "../Context/Contexto";
import { CargasBoton, Pago, perfil, preAlerta } from "../Model/BotonesInicio";
import { Alerta1 } from "../Componentes/Divs";
import AmigoReferidos from "./AmigoReferidos";
import Botones from "./Botones";
import { Casillas } from "../Componentes/Casillas";
import { Espana, Miami } from "../Model/CasillasInicio";
import RastreosHistorial from "./RastreosHistorial";
import { AmigoReferid, Carga, cuentaCliente, Pagos } from "../Rutas/Servicios";
import { Mostrar } from "../Context/Mostrando";
import PagosAnterior from "./PagosAnterior";
import { PagoPendiente } from "../Model/Tablas/PagoPendiente";
import { NotificacionesGeneral } from "../Context/Notificaciones_Context";
import { RetiroPendientes } from "../Model/Tablas/RetiroPendientes";
import OrdenesRetiro from "./OrdenesRetiro";
import { Alerta2 } from "../Componentes/Alerta2";
import { Get, Post2, Put } from "../Rutas/ApiRest";
import { MensajeContActualizacion } from "../Context/MensajeContextActualizacion";
import { tokens } from "../Context/Tokens";
import Historial from "./Historial";
import { ReferenciaDTO } from "../Model/ReferenciaDTO";
import {ActivarRedireccion, Calculadora, Loading, Loading2, Modelos} from "./Modelos";
import { CalculadoraDTO } from "../Model/CalculadoraDTO";
import { SucursalesDTO } from "../Model/SucursalesDTO";
import SinFacturaRastreo from "./SinFacturaRastreo";
import PreAlertas from "./PreAlertas";
import Cupones from "./Cupones";
import DocumentoFaltanteAduana from "./DocumentosFaltanteAduana";
import { GuiaBusquedaCont } from "../Context/BusquedaGuiaContext";
import VendemosContigoSin from "./VendemosContigoSin";
import VendemosContigoCon from "./VendemosContigoCon";
import HistorialPuntos from "./HistorialPuntos";
import HistorialAmigoReferido from "./HistorialAmigoReferido";

import ReactGA from 'react-ga4';

function CuentaNew ()
{
    const formatter = new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 0
      })
    const {SetGuiaBusquedaPreAlerta}=useContext(GuiaBusquedaCont)
    const {Cli}=useContext(Contexto)
    const {ActualizarSexo}=useContext(Contexto)
    const {Mostrardo}=useContext(Mostrar)
    const {toggleTodo}=useContext(tokens)
    const {NotifiContext}=useContext(NotificacionesGeneral)
    const {SetCasillaCalculadora,SetMensajeEmergente,BusquedaShow,SetLoading,SetBusquedaShow}=useContext(MensajeContActualizacion)
    const [Api,SetApi]=useState<string>("")
    const {tok}=useContext(tokens)
    const [sexo,SetSexo]=useState<number>(Cli.sexo)
    const [tipoDireccion,SetTipoDireccion]=useState<string>(Cli.lDirecciones[0].tipoDireccion)
    const {Actualizar}=useContext(Mostrar)
    const {ActualizarCli}=useContext(Contexto)
    const [iddireccion,Setiddireccion]=useState<number>(0)
    const [Comuna,SetComuna]=useState<number>(Cli.lDirecciones[iddireccion].idComuna)
    const [region,SetRegion]=useState<number>(Cli.lDirecciones[iddireccion].idRegion)
    const [SelectDirecciones,SetSelectDireciones]=useState<any[]>([])
    const [SelectRegiones,SetSelectRegiones]=useState<any[]>([])
    const [SelectComuna,SetSelectComuna]=useState<any[]>([])
    const [SelectComunaCalculadora,SetSelectComunaCalculadora]=useState<any[]>([])
    const [Empresa,SetEmpresa]=useState<boolean>(false)
    const [Sucursal,SetSucursal]=useState<SucursalesDTO[]>([])
    const [SelectComunaFacturacion,SetSelectComunaFacturacion]=useState<any[]>([])
    const [SelectRegionFacturacion,SetSelectRegionFacturacion]=useState<any[]>([])
    const fecha=new Date(Cli.fechaNacimiento)
    const Reset:CalculadoraDTO=
    {
      domicilio:-1,
      seguro:-1,
      Manejo:-1,
      Flete:1
    }
    const [DatosCalculadora,SetDatosCalculadora]=useState<CalculadoraDTO>(Reset)
    
    const url="<iframe src='https://eboxwidget.mbe-latam.com/@id' style='width:100%; height:800px; border:none;'></iframe>";
    const [state,dispatch]=useReducer(reducer,{nombre:"",apellido:"",email:"",confirmacionEmail:"",claves:"",confirmacionClave:"",fechaNacimiento:""})
    const [statePreferencia,dispachPreferencia]=useReducer(reducerPreferencia,{calle:"",numero:"",ciudad:"",telefono:"",complementario:""})
    const [stateCaluladora,dispachCalculadora]=useReducer(reducerCalculadora,{Precio:1,valor:0,peso:0,idPeso:0,despacho:-1,comuna:"",mensaje:true})
    const [stateFacturacion,dispachFacturacion]=useReducer(reducerFacturador,{calle:Cli.lDirecciones[Cli.lDirecciones.length-1].direccion,numero:Cli.lDirecciones[Cli.lDirecciones.length-1].numero,id_comuna:Cli.lDirecciones[Cli.lDirecciones.length-1].idComuna,id_region:Cli.lDirecciones[Cli.lDirecciones.length-1].idRegion,ciudad:Cli.lDirecciones[Cli.lDirecciones.length-1].ciudad,telefono:Cli.lDirecciones[Cli.lDirecciones.length-1].telefono,complemento:Cli.lDirecciones[Cli.lDirecciones.length-1].infoAdicional})
    function reducer(state:any,action:any)
    {
      switch(action.type)
      {
        
        case "cambio":return {
          ...state,[action.input.name]:action.input.value
        }
        case "Reinicio":
          {
            return {nombre:Cli.nombre,apellido:Cli.apellidoPaterno,email:Cli.email,confirmacionEmail:Cli.email,claves:"",confirmacionClave:"",fechaNacimiento:fecha.toLocaleDateString('en-ZA').replace("/","-").replace("/","-")}
        }
          
         
      }
    
      return state;
    }

    function reducerCalculadora(state:any,action:any)
    {
      switch(action.type)
      {
        case "cambio":return {
          ...state,[action.input.name]:action.input.value
        }
      }
    
      return state;
    }

    function reducerPreferencia(state:any,action:any)
    {
      switch(action.type)
      {
        case "cambio":return {
          ...state,[action.input.name]:action.input.value
        }
        case "Reinicio":
          return {calle:Cli.lDirecciones[iddireccion].direccion!="Agregar Nueva Direccion"?Cli.lDirecciones[iddireccion].direccion:"",numero:Cli.lDirecciones[iddireccion].numero,ciudad:Cli.lDirecciones[iddireccion].ciudad,telefono:Cli.lDirecciones[iddireccion].telefono==undefined?"":Cli.lDirecciones[iddireccion].telefono,complementario:Cli.lDirecciones[iddireccion].infoAdicional}
      }
    
      return state;
    }

    function reducerFacturador(state:any,action:any)
    {
      switch(action.type)
      {
        case "cambio":return {
          ...state,[action.input.name]:action.input.value
        }
        case "Reinicio":
          {
            const facturacion=Cli.lDirecciones[Cli.lDirecciones.length-1]
            return {calle:facturacion.direccion,numero:facturacion.numero,id_comuna:facturacion.idComuna,id_region:facturacion.idRegion,ciudad:facturacion.ciudad,telefono:facturacion.telefono,complemento:facturacion.infoAdicional}
          }
      }
    
      return state;
    }

    
    function cambio(event:any)
    {
      dispatch({type:"cambio",input:{
        name:event.target.name,
        value:event.target.value
      }})
      
    }

    function cambioPreferencia(event:any)
    {

      dispachPreferencia({type:"cambio",input:{
        name:event.target.name,
        value:event.target.value
      }})
    }
    function CambioCalculadora(values:number)
    {
      dispachCalculadora({type:"cambio",input:{
        name:"Precio",
        value:values
      }})
    }

    const SelectCalPeso=(event:any)=>
    {
      dispachCalculadora({type:"cambio",input:{
        name:"idPeso",
        value:event.target.value
      }})
    }

    const SelectCalDespacho=(event:any)=>
    {
      SetSelectComunaCalculadora([])
      dispachCalculadora({type:"cambio",input:{
        name:"despacho",
        value:event.target.value
      }})
    }

    useEffect(()=>
    {
      
      if(stateCaluladora.despacho>-1)
      {
        const datos=Get(Carga.SucursalesBusqueda.replace("@idRegion",stateCaluladora.despacho) ,"application/json",tok)
        datos?.then(resultado=>{
          resultado.map((e:any)=>
          {
            SetSelectComunaCalculadora((a:any)=>[...a,<option value={e.nombre}>{e.nombre}</option>])
          });
          dispachCalculadora({type:"cambio",input:{
            name:"comuna",
            value:resultado[0].nombre
          }})
        })
      }else
      {
        dispachCalculadora({type:"cambio",input:{
          name:"comuna",
          value:"-1"
        }})
      }

    },[stateCaluladora.despacho])

    const cambioComunaCal=(event:any)=>
    {
      dispachCalculadora({type:"cambio",input:{
        name:"comuna",
        value:event.target.value
      }})
    }

    function CambioCal(event:any)
    {
      
      const number:string=event.target.value
      
      if(event.target.value>0)
      {
        if(number.charAt(0)=="0")
        {
          dispachCalculadora({type:"cambio",input:{
            name:event.target.name,
            value:event.target.value.slice(1)
          }})
        }else
        {
          dispachCalculadora({type:"cambio",input:{
            name:event.target.name,
            value:event.target.value
          }})
        }
      }else
      {
        dispachCalculadora({type:"cambio",input:{
          name:event.target.name,
          value:0
        }})
      }

     
    }

    useEffect(()=>{
      var envio=""
      if(Mostrardo!=ReferenciaDTO.UbicacionActualizarDomicilio)
      {
        SetSelectComuna([]);
        SetSelectDireciones([]);
        SetSelectRegiones([]);
      }else
      {
        SetTipoDireccion(Cli.lDirecciones[0].tipoDireccion)
        ActualizarRegiones();
        Cli.lDirecciones.map((e:any)=>
      {
        if(e.tipoDireccion=="DESPACHO A DOMICILIO")
        {
          SetSelectDireciones((a:any)=>[...a,<option value={e.idUbicacion} key={e.idUbicacion}>{e.direccion +" "+e.numero+","+e.comuna+","+e.ciudad}</option>])
        }
      })
      }
      if(Mostrardo!=ReferenciaDTO.UbicacionActualizar)
      {
        SetSelectComunaFacturacion([]);
        SetSelectRegionFacturacion([]);
      }else
      {
        dispachFacturacion({type:"Reinicio"})
        actualizarComunaPreferente(stateFacturacion.id_region)
      }
      if(Mostrardo!=ReferenciaDTO.UbicacionCalculadora)
      {
        SetDatosCalculadora(Reset)
      }

      if(Mostrardo!=ReferenciaDTO.UbicacionSinFactura)
      {
        SetGuiaBusquedaPreAlerta("")
      }

      switch (Mostrardo)
      {
        case ReferenciaDTO.UbicacionHistorial:window.location.href="#historial";
              envio="Historial" 
              break;
        case ReferenciaDTO.UbicacionPagoPendiente:window.location.href="#pago"
              envio="Pago Pendientes" 
              break;
        case ReferenciaDTO.UbicacionPrepago:window.location.href="#prepago"
              envio="Prepago" 
            break; 
            
        case ReferenciaDTO.UbicacionCarga: window.location.href="#rastreo"
              envio="Rastreo" 
            break;
        case ReferenciaDTO.UbicacionPreAlerta:window.location.href="#prealerta";
              envio="PreAlertas" 
            break;
        case ReferenciaDTO.UbicacionPreferencia:window.location.href="#preferencia";
            envio="Datos Casillas" 
          break;
         case ReferenciaDTO.UbicacionEntrega:window.location.href="#Entrega";
              envio="Actualizacion preferencia de entrega" 
          break;
          case ReferenciaDTO.UbicacionCalculadora:
              envio="Calculadora"
          break;
          case ReferenciaDTO.UbicacionHistorialPuntos:
              envio="Historial Puntos Rewards"
          break;
          case ReferenciaDTO.UbicacionAmigoReferido:
              envio="Historial Amigo Referido"
          break;
          case ReferenciaDTO.UbicacionCupones:
              envio="Cupones"
          break;
          case ReferenciaDTO.UbicacionDocumentacion:
              envio="Subir Documentos"
          break;
          case ReferenciaDTO.UbicacionSinFactura:
              envio="Sin Facturas"
          break;
          case ReferenciaDTO.UbicacionActualizar:
              envio="Actualizacion preferencia de entrega"
          break;
          case ReferenciaDTO.UbicacionVendemosContigo:
              envio="Vendemos Contigo"
          break;
          case ReferenciaDTO.UbicacionActualizarDomicilio:
            envio="Actualizacion Domicilio"
        break;
        
      }

      if(envio!="")
        {
          ReactGA.send({
            hitType:"pageview",
            page:"/",
            title:envio
          })
          console.log(envio)
        }
      
    },[Mostrardo])
    useEffect(()=>
    {
      const datos=Get(AmigoReferid.ValidacionEmpresa.replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode) ,"application/json",tok)
        datos?.then(resultado=>{SetEmpresa(resultado)})

        const consulta=Get(Carga.Sucursal,'application/json',tok)
        consulta.then(resultado=>SetSucursal(resultado))

        
    },[])
    
    const actualizarComunaPreferente=(id:number)=>
    {
      const dato2=Get(cuentaCliente.Comunas.replace("@idregion",id+""),"application/json",tok);
        dato2.then(resultado=>{dispachFacturacion({type:"cambio",input:{
          name:"id_comuna",
          value:resultado[0].id_comuna
        }});
        resultado.map((e:any)=>{
          

          if(e.id_comuna==Cli.lDirecciones[Cli.lDirecciones.length-1].idComuna)
          {
            SetSelectComunaFacturacion((a:any)=>[...a,<option value={e.id_comuna} selected>{e.nombre}</option>])
            dispachFacturacion({type:"cambio",input:{
              name:"id_comuna",
              value:e.id_comuna
            }});
          }else
          {
            SetSelectComunaFacturacion((a:any)=>[...a,<option value={e.id_comuna}>{e.nombre}</option>])
            
          }
          
        })
        
      })
    }

    const cambioComunaFacturacion=(event:any)=>
    {
      dispachFacturacion({type:"cambio",input:{
        name:"id_comuna",
        value:event.target.value
      }})
    }

    const cambioSelectFacturacion=(event:any)=>
    {
      SetSelectComunaFacturacion([])
      actualizarComunaPreferente(event.target.value)
      dispachFacturacion({type:"cambio",input:{
        name:"id_region",
        value:event.target.value
      }})
      
    }

    const cambio2=(event:any)=>
    {
      SetSexo(event.target.value);
    }

    const CambioDireccion=(event:any)=>
    {
      
      SetTipoDireccion(event.target.value)
      if(SelectDirecciones[0].key!=undefined)
      {
        Setiddireccion(parseInt(SelectDirecciones[0].key))
      }
    }

    const CambioRegion=(event:any)=>
    {
      SetSelectComuna([]);
      SetRegion(event.target.value)
    }

    const CambioComuna=(event:any)=>
    {
      SetComuna(event.target.value)
    }

    useEffect(()=>{
      if(Cli.lCasilla[Cli.Eleccion].ecode!="")
            {
              const dato3=Get(cuentaCliente.ApiZoom.replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode),"application/json",tok)
              dato3?.then(resultado=>{SetApi(resultado)})
            }
    },[Cli.Eleccion])

    useEffect(()=>{
      if(Cli.lCasilla[Cli.Eleccion].ecode!="")
            {

              const dato3=Get(cuentaCliente.ApiZoom.replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode),"application/json",tok)
              dato3?.then(resultado=>{SetApi(resultado)})
            }
            dispatch({type:"Reinicio"})
    },[Cli.lCasilla])

    useEffect(()=>
    {
      SetSelectComuna([]);
      var dato=0
      const dato2=Get(cuentaCliente.Comunas.replace("@idregion",region+""),"application/json",tok);
      dato2.then(resultado=>{
        resultado.map((e:any)=>{
          if(e.id_comuna==Cli.lDirecciones[iddireccion].idComuna)
          {
            SetSelectComuna((a:any)=>[...a,<option value={e.id_comuna} selected>{e.nombre}</option>])
            dato=e.id_comuna;
          }else
          {
            SetSelectComuna((a:any)=>[...a,<option value={e.id_comuna}>{e.nombre}</option>])
          }
          
        })
        if(dato==0)
        {
          SetComuna(resultado[0].id_comuna)
        }else
        {
          SetComuna(dato)
        }
      }
      )
    },
    [region])

    const ActualizarDatos=()=>
    {
      toggleTodo();
      
      if(state.nombre=="" || state.apellido=="" || state.email=="")
      {
        SetMensajeEmergente("Debe completar todos los datos");
      }else
      {
          if(state.email!=state.confirmacionEmail)
          {
            SetMensajeEmergente("Email no coincide");
          }else
          {
            if(state.claves!=state.confirmacionClave)
            {
              SetMensajeEmergente("Contraseñas no coinciden");
            }else
            {
              if(state.claves.length<6 && state.claves.length!=0)
              {
                SetMensajeEmergente("Contraseñas no coinciden");
              }else
              {
                var body={"nombre": state.nombre,
                "apellidoPaterno": state.apellido,
                "rut": Cli.rut,
                "email": state.email,
                "contrasena":state.claves,
                "sexo":sexo,
                 "fechaNacimiento":state.fechaNacimiento}
                const dato3=Put(cuentaCliente.ModificarCuenta,"application/json",tok,JSON.stringify(body))
                dato3?.then(resultado=>{ActualizarSexo(sexo);SetMensajeEmergente(resultado);
                  const datos=Get(cuentaCliente.DatosClientes.replace("@rut",Cli.rut),"application/json",tok)
                  datos.then(resultado2=>{ActualizarCli(resultado2);})})
                dispatch({type:"Reinicio"})
              }
            }
          }
          
      }
      SetLoading(false);
    }

    const Calcular=()=>
    {
      if(stateCaluladora.peso<=0 || stateCaluladora.valor<=0)
      {
        SetMensajeEmergente("Ingrese valor del producto y peso")
        
      }else
      {
        var pes=stateCaluladora.peso
        if(stateCaluladora.idPeso==1)
        {
          pes=stateCaluladora.peso/2.2
        }

        if(pes>1000)
        {
          SetMensajeEmergente("Peso erróneo")
        }else
        {
          if(stateCaluladora.valor>1000000)
          {
            SetMensajeEmergente("Valor del producto no válido")
          }else
          {
            var body={"valorFob":stateCaluladora.valor,
            "peso":pes,
            "Domicilio":stateCaluladora.domicilio,
            "tienda":stateCaluladora.Precio,
            "comuna":stateCaluladora.comuna}

            const dato3=Post2(Carga.Calculadora,JSON.stringify(body),"application/json","")
            dato3?.then(resultado=>{if(resultado.domicilio==0 && stateCaluladora.comuna!="-1")
            {
              dispachCalculadora({type:"cambio",input:{
                name:"mensaje",
                value:true
              }})
            }else
            {
              dispachCalculadora({type:"cambio",input:{
                name:"mensaje",
                value:false
              }})
            }
            SetDatosCalculadora(resultado);
              
            })
          }
        }
        
        
        
      }
    }

   


    const cambioDireccione=(event:any)=>
    {
      SetSelectRegiones([]);
      Setiddireccion(event.target.value)
    }
    useEffect(()=>
    {
      
      ActualizarRegiones();
            
    },[iddireccion])

    const ActualizarDatosFacturacion=()=>
    {
      const verificacionTelefonos=VerificacionTelefono(stateFacturacion.telefono)
      if(stateFacturacion.calle.length>2 && stateFacturacion.numero.length>0 && stateFacturacion.ciudad.length>3 && verificacionTelefonos)
      {
        toggleTodo()
      var body={
                "rut": Cli.rut,
                "direccion":
                {
                  "direccion":stateFacturacion.calle,
                  "numero":stateFacturacion.numero,
                  "ciudad":stateFacturacion.ciudad,
                  "telefono":stateFacturacion.telefono,
                  "infoAdicional":stateFacturacion.complemento,
                  "idRegion":stateFacturacion.id_region,
                  "idComuna":stateFacturacion.id_comuna,
                }
              }
       const dato3=Post2(cuentaCliente.DatosFacturacion,JSON.stringify(body),"application/json",tok)
                dato3?.then(resultado=>{SetMensajeEmergente(resultado);
                  const datos=Get(cuentaCliente.DatosClientes.replace("@rut",Cli.rut),"application/json",tok)
                  datos.then(resultado=>{ActualizarCli(resultado);Actualizar(ReferenciaDTO.UbicacionPreferencia)})
                  })
                
              
      }else
      {
        if(stateFacturacion.calle.length<3)
        {
          SetMensajeEmergente("Estimado Cliente, debe ingrese una dirección correcta")
        }else
        {
          if(stateFacturacion.numero.length<1)
          {
            SetMensajeEmergente("Estimado Cliente, debe ingresar un número de calle correcto.");
          }else
          {
            if(stateFacturacion.ciudad.length<4)
            {
              SetMensajeEmergente("Estimado Cliente, debe ingresar una ciudad correcta.");
            }else
            {
              if(!verificacionTelefonos)
              {
                SetMensajeEmergente("Estimado Cliente, debe ingresar un número de teléfono valido.");
              }
            }
          }
        }
        
      }
     
    }


    const CambioFacturacion=(event:any)=>
    {
      dispachFacturacion({type:"cambio",input:{
        name:event.target.name,
        value:event.target.value
      }})
    }


    const ActualizarRegiones=()=>
    {
      if(SelectRegiones.length==0)
      {
        const dato2=Get(cuentaCliente.Regiones,"application/json",tok);
            dato2.then(resultado=>{
              resultado.map((e:any)=>{
                if(e.idRegion==Cli.lDirecciones[iddireccion].idRegion)
                {
                  SetSelectRegiones((a:any)=>[...a,<option value={e.idRegion} selected>{e.nombreRegion}</option>])
                }else
                {
                  SetSelectRegiones((a:any)=>[...a,<option value={e.idRegion}>{e.nombreRegion}</option>])
                }
                
                
              })
            }
            )
            
      }
      dispachPreferencia({type:"Reinicio"});
      if(region==Cli.lDirecciones[iddireccion].idRegion)
      {
        SetSelectComuna([]);
        const dato2=Get(cuentaCliente.Comunas.replace("@idregion",region+""),"application/json",tok);
        dato2.then(resultado=>{
        resultado.map((e:any)=>{
          if(e.id_comuna==Cli.lDirecciones[iddireccion].idComuna)
          {
            SetSelectComuna((a:any)=>[...a,<option value={e.id_comuna} selected>{e.nombre}</option>])
          }else
          {
            SetSelectComuna((a:any)=>[...a,<option value={e.id_comuna}>{e.nombre}</option>])
          }
          
        })
      }
      )
      }else
      {
        SetRegion(Cli.lDirecciones[iddireccion].idRegion)
      }
      
      
    }
    const VerificacionTelefono=(telefono:string)=>
    {
       try 
       {
        if(telefono.charAt(0)=="+")
        {
          telefono=telefono.slice(1)
        }
        const prueba:number=Number(telefono.replace(" ",""))
        if(prueba>0)
        {
          if(telefono.length<7 || telefono.length>13)
          {
            return false;
          }else
          {
            return true;
          }
        }else
        {
          return false
        }
        

       } catch (e) {
          return false;
       }
    }

    const ActualizarPreferencia=()=>
    {
      const verificacionTelefonos=VerificacionTelefono(statePreferencia.telefono)
        if(statePreferencia.tipoDireccion!="DESPACHO A DOMICILIO")
        {
          toggleTodo()
          var body={
                    "rut": Cli.rut,
                    "direccion":
                    {
                      "tipodireccion":tipoDireccion,
                      "idDireccion":Cli.lDirecciones[iddireccion].idDireccion,
                      "direccion":statePreferencia.calle,
                      "numero":statePreferencia.numero,
                      "ciudad":statePreferencia.ciudad,
                      "telefono":statePreferencia.telefono,
                      "infoAdicional":statePreferencia.complementario,
                      "idRegion":region,
                      "idComuna":Comuna,
                    }
                  }
           const dato3=Post2(cuentaCliente.ActualizarPreferencia,JSON.stringify(body),"application/json",tok)
                    dato3?.then(resultado=>{SetMensajeEmergente(resultado);
                      const datos=Get(cuentaCliente.DatosClientes.replace("@rut",Cli.rut),"application/json",tok)
                      datos.then(resultado=>{ActualizarCli(resultado);Actualizar(ReferenciaDTO.UbicacionPreferencia)})
                      Setiddireccion(0)
                      dispachPreferencia({type:"Reinicio"})})
                    
                    
        }else
        {
          if(statePreferencia.calle.length>2 && statePreferencia.numero.length>0 && statePreferencia.ciudad.length>3 && verificacionTelefonos)
          {
            toggleTodo()
          var body={
                    "rut": Cli.rut,
                    "direccion":
                    {
                      "tipodireccion":tipoDireccion,
                      "idDireccion":Cli.lDirecciones[iddireccion].idDireccion,
                      "direccion":statePreferencia.calle,
                      "numero":statePreferencia.numero,
                      "ciudad":statePreferencia.ciudad,
                      "telefono":statePreferencia.telefono,
                      "infoAdicional":statePreferencia.complementario,
                      "idRegion":region,
                      "idComuna":Comuna,
                    }
                  }
           const dato3=Post2(cuentaCliente.ActualizarPreferencia,JSON.stringify(body),"application/json",tok)
                    dato3?.then(resultado=>{SetMensajeEmergente(resultado);
                      const datos=Get(cuentaCliente.DatosClientes.replace("@rut",Cli.rut),"application/json",tok)
                      datos.then(resultado=>{ActualizarCli(resultado);Actualizar(ReferenciaDTO.UbicacionPreferencia)})
                      Setiddireccion(0)
                      dispachPreferencia({type:"Reinicio"})})
                    
                  
          }else
          {
            if(statePreferencia.calle.length<3)
            {
              SetMensajeEmergente("Estimado Cliente, debe ingrese una dirección correcta")
            }else
            {
              if(statePreferencia.numero.length<1)
              {
                SetMensajeEmergente("Estimado Cliente, debe ingresar un número de calle correcto.");
              }else
              {
                if(statePreferencia.ciudad.length<4)
                {
                  SetMensajeEmergente("Estimado Cliente, debe ingresar una ciudad correcta.");
                }else
                {
                  if(!verificacionTelefonos)
                  {
                    SetMensajeEmergente("Estimado Cliente, debe ingresar un número de teléfono valido.");
                  }
                }
              }
            }
            
          }
        }

        
                
    }

    const EliminarPreferencia=()=>
    {
      toggleTodo()
      var body={
                "rut": Cli.rut,
                "direccion":
                {
                  "idDireccion":Cli.lDirecciones[iddireccion].idDireccion,
                }
              }
       const dato3=Post2(cuentaCliente.EliminarPreferencia,JSON.stringify(body),"application/json",tok)
                dato3?.then(resultado=>{SetMensajeEmergente(resultado)})
                
                 const datos=Get(cuentaCliente.DatosClientes.replace("@rut",Cli.rut),"application/json",tok)
                 datos.then(resultado=>{ActualizarCli(resultado);Actualizar(ReferenciaDTO.UbicacionPreferencia)})
    }
  
    return (
        <>
          <Alerta2></Alerta2>
          <Alerta1></Alerta1>
           
            <div className="pagetitle">
                <h1>Home</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a >Mi Cuenta</a></li>
                    </ol>
                </nav>
            </div>
            <section className="section">
                <div className="row row__item">
                    <Botones dato={perfil} titulo={Empresa?<>{Cli.nombre+" "+Cli.apellidoPaterno}</>:Cli.nombre} actualiza={ReferenciaDTO.UbicacionPreferencia}></Botones>
                    <Botones dato={preAlerta} titulo="Prealerta" actualiza={ReferenciaDTO.UbicacionPreAlerta}></Botones>
                    <Botones dato={CargasBoton} titulo="Mis Cargas" actualiza={ReferenciaDTO.UbicacionCarga}></Botones> 
                    <Botones dato={Pago} titulo={NotifiContext[1].cantidad==0?"Sin Pagos Pendientes":NotifiContext[1].cantidad==1?NotifiContext[1].cantidad+" Pago Pendiente":NotifiContext[1].cantidad+" Pagos Pendientes"} actualiza={ReferenciaDTO.UbicacionPagoPendiente}></Botones>
                </div>
            </section>

            {/* Casilla y preferencias entrega */}


            {Mostrardo==ReferenciaDTO.UbicacionPreferencia || Mostrardo==ReferenciaDTO.UbicacionEntrega?<section className="section" id="preferencia">
                <div className="row" >
                    <div className="col-12 col-md-6" >
                            <div className="card">
                            <div className="card-body" >
                                <h5 className="card-title"> </h5>
                                <div className="accordion" id="accordionTabla" >
                                <Casillas dato={Miami} estado={Cli.lCasilla[Cli.Eleccion].Contenido.CasillaMiami}></Casillas>
                                <Casillas dato={Espana} estado={Cli.lCasilla[Cli.Eleccion].Contenido.CasillaEspana}></Casillas>
                                </div>
                            </div>
                            </div>
                        </div>
                    <div className="col-12 col-md-6" >
        <div className="fondo-blanco h-100">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title"> </h5>
              <div className="accordion" id="accordionFlushTabla">
                <div className="accordion-item" id="Entrega">
                  <h2 className="accordion-header" id="flush-headingOne">
                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne"> Preferencias de Entrega </button>
                  </h2>
                  <div id="flush-collapseOne" className="accordion-collapse show" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushTabla">
                    <div className="accordion-body">
                      <p><strong>{Cli.lDirecciones[0]!=undefined?Cli.lDirecciones[0].tipoDireccion:""}</strong></p>
                      <p><strong>Región:</strong> {Cli.lDirecciones[0]!=undefined?Cli.lDirecciones[0].region:""}<br/>
                        <strong>Ciudad:</strong> {Cli.lDirecciones[0]!=undefined?Cli.lDirecciones[0].ciudad:""}<br/>
                        <strong>Comuna: </strong>{Cli.lDirecciones[0]!=undefined?Cli.lDirecciones[0].comuna:""}<br/>
                        <strong>Dirección: </strong>{Cli.lDirecciones[0]!=undefined?Cli.lDirecciones[0].direccion:null}<br/>
                        {Cli.lDirecciones[0]!=undefined?Cli.lDirecciones[0].numero!=""?<><strong>Numero:</strong>{Cli.lDirecciones[0].numero} <br/> </> :null:null}
                        {Cli.lDirecciones[0]!=undefined?Cli.lDirecciones[0].infoAdicional!=""?<><strong>Información complementaria: </strong>{Cli.lDirecciones[0].infoAdicional} </>:null:null}</p>
                        <p className="small"><a href="#editar" onClick={()=>Actualizar(ReferenciaDTO.UbicacionActualizarDomicilio)}><i className="bi bi-pen"></i> Editar información</a></p>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingTwo">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo"> Lugares de Retiro </button>
                  </h2>
                  <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushTabla">
                    <div className="card-body">
                      <p><strong className="color-corporativo">LAS CONDES</strong></p>
                      <p>{Sucursal[0]!=undefined?(Sucursal[0]?.direccion).replace(", Las Condes",""):null}<br/>
                        <strong>Horario de atención:</strong></p>
                      <p>{Sucursal[0]?.Atencion}</p>
                      <div className="py-3">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5934.568108564439!2d-70.54630754783449!3d-33.40593299856984!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662cebde799f453%3A0xfdee4ece40a93e53!2sPadre%20Hurtado%20Central%201531%2C%20Las%20Condes%2C%20Regi%C3%B3n%20Metropolitana!5e0!3m2!1ses!2scl!4v1649690732564!5m2!1ses!2scl" style={{width:"100%",height:"250",border:0}}  loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                      </div>
                    </div>
                  </div>
                </div>          
              </div>
            </div>
          </div>
        </div>
                </div>
                </div>
            </section>:Mostrardo==ReferenciaDTO.UbicacionCarga || Mostrardo==ReferenciaDTO.UbicacionHistorial?<div className="row" id="rastreo">
            <div className="fondo-blanco h-100">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title"> </h5>
              <div className="accordion" id="accordionExample">
  <div className="accordion-item">
    <h2 className="accordion-header" id="headingOne">
      <button className={BusquedaShow=="Rastreo"?"accordion-button":"accordion-button collapsed"} type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded={BusquedaShow=="Rastreo"?true:false} aria-controls="collapseOne" onClick={()=>SetBusquedaShow("Rastreo")}>
      Rastreo de Carga
      </button>
    </h2>
    <div id="collapseOne" className={BusquedaShow=="Rastreo"?"accordion-collapse collapse show":"accordion-collapse collapse"} aria-labelledby="headingOne" data-bs-parent="#accordionExample">
      <div className="accordion-body">
      {Cli.lCasilla[0].ecode!=""?<RastreosHistorial ></RastreosHistorial>:null}
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="headingTwo">
      <button className={BusquedaShow=="Historial"?"accordion-button":"accordion-button collapsed"}  type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded={BusquedaShow=="Historial"?true:false} aria-controls="collapseTwo" onClick={()=>SetBusquedaShow("Historial")}>
        Historial de Carga
      </button>
    </h2>
    <div id="collapseTwo" className={BusquedaShow=="Historial"?"accordion-collapse collapse show":"accordion-collapse collapse"} aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
      <div className="accordion-body">
      {Cli.lCasilla[0].ecode!=""?<Historial ></Historial>:null}
      </div>
    </div>
  </div>
</div>
              </div>
              </div>
              </div>
		  </div>:Mostrardo==3?<> <div className="row" id="pago">
    <div className="col-sm-12">
      <section className="card iconos py-sm-3">
        <div className="card-body text-secondary px-sm-4" >
          <p className="subtitulo" >Carga Pendiente de Pago</p>
          {Cli.lCasilla[0].ecode!=""?<PagosAnterior Categoria={"PagoPendiente"} Link={Pagos.PagoPendientes} Columna={PagoPendiente} id="Ther"></PagosAnterior>:null}
		  </div>
		  </section>
        
		  </div>
         
		  </div>
      </>
      :Mostrardo==ReferenciaDTO.UbicacionPrepago?<div className="row" id="prepago">
    <div className="col-sm-12">
      <section className="card iconos py-sm-3">
        <div className="card-body text-secondary px-sm-4" >
          <p className="subtitulo" >Ordenes para retiro</p>
          {Cli.lCasilla[0].ecode!=""?<OrdenesRetiro Link={Carga.Retiro} Columna={RetiroPendientes} id="Ther"></OrdenesRetiro>:null}
		  </div>
		  </section>
        
		  </div>
         
		  </div>
      :Mostrardo==ReferenciaDTO.UbicacionPreAlerta?
      <>
       <PreAlertas></PreAlertas>
      </>
      :Mostrardo==ReferenciaDTO.UbicacionActualizar?<>
      <div className="row">
         <div className="col-12 col-md-6" id="actualizar">
      <section className="card iconos py-sm-3">
        <div className="card-body text-secondary px-sm-4" >
          <p className="subtitulo" >Actualiza tus datos</p>
          <div className="accordion-item">
                                    
                                    <div className="accordion-collapse collapse show" data-bs-parent="#accordionTabla">
                                    <div className="accordion-body">
                                        <table className="table table-striped table-bordered" style={{width:"100%"}} cellSpacing="0" cellPadding="0">
                                            <tbody>
                                                <tr>
                                                    <td><strong>Nombre</strong></td>
                                                    <td><span id=""><input className="col-12 col-m-8" value={state.nombre} name="nombre" onChange={cambio}></input></span> </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Apellido</strong></td>
                                                    <td><span id=""><input className="col-12 col-m-8" value={state.apellido} name="apellido" onChange={cambio}></input></span> </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Sexo</strong></td>
                                                    <td><span id=""><select className="col-12 col-m-8" defaultValue={Cli.sexo} onChange={cambio2}>
                                                      <option value={0} >Selecciona</option>
                                                      <option value={1} >Femenino</option>
                                                      <option value={2} >Masculino</option>
                                                    </select>
                                                      </span> </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Email</strong></td>
                                                    <td><span id=""><input className="col-12 col-m-8" value={state.email} name="email" onChange={cambio}></input></span> </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Confirmar Email</strong></td>
                                                    <td><span id=""><input className="col-12 col-m-8" value={state.confirmacionEmail} name="confirmacionEmail" onChange={cambio}></input></span> </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Clave</strong></td>
                                                    <td><span id=""><input className="col-12 col-m-8" value={state.claves} type="password" name="claves" onChange={cambio}></input></span> </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Confirmar Clave</strong></td>
                                                    <td><span id=""><input className="col-12 col-m-8" value={state.confirmacionClave} type="password" name="confirmacionClave" onChange={cambio}></input></span> </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Fecha de Nacimiento</strong></td>
                                                    <td><input type="date" name="fechaNacimiento" value={state.fechaNacimiento} onChange={cambio}></input> </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div >
                                          <input type="submit" name="ctl00$ContentPlaceHolder_body$Agregar_btn" value="Actualiza tus datos" id="ContentPlaceHolder_body_Agregar_btn" className="btn btn-primary" style={{backgroundColor:"#f98824",borderColor:"#f98824"}} onClick={()=>{SetLoading(true);ActualizarDatos()}}/>
                                         
                                      </div>
                                      <br/>
                                    </div>
                                    </div>
                                </div>
		  </div>
		  </section>
		  </div>
      <div className="col-12 col-md-6" id="actualizar">
      <section className="card iconos py-sm-3">
        <div className="card-body text-secondary px-sm-4" >
          <p className="subtitulo" >Actualiza tu Dirección de facturación</p>
          <div className="accordion-item">
                                    
                                    <div className="accordion-collapse collapse show" data-bs-parent="#accordionTabla">
                                    <div className="accordion-body">
                                        <table className="table table-striped table-bordered" style={{width:"100%"}} cellSpacing="0" cellPadding="0">
                                            <tbody>
                                            <tr>
                                                 <td><strong>Calle</strong></td>
                                                 <td><span id=""><input  className="col-12 col-m-8" value={stateFacturacion.calle} name="calle" onChange={CambioFacturacion}></input></span> </td>
                                             </tr>
                                             <tr>
                                                 <td><strong>Numero Calle</strong></td>
                                                 <td><span id=""><input className="col-12 col-m-8" value={stateFacturacion.numero} name="numero" onChange={CambioFacturacion}></input></span> </td>
                                             </tr>
                                             <tr>
                                                 <td><strong>Region</strong></td>
                                                 <td>
                                                   <select className="col-12 col-m-8" name="region" defaultValue={stateFacturacion.id_region} onChange={cambioSelectFacturacion}>
                                                   <option value="1">Región I</option>
                                                    <option value="2">Región II</option>
                                                    <option value="3">Región III</option>
                                                    <option value="4">Región IV</option>
                                                    <option value="5">Región V</option>
                                                    <option value="6">Región VI</option>
                                                    <option value="7">Región VII</option>
                                                    <option value="8">Región VIII</option>
                                                    <option value="9">Región IX</option>
                                                    <option value="10">Región X</option>
                                                    <option value="11">Región XI</option>
                                                    <option value="12">Región XII</option>
                                                    <option value="13">Región Metropolitana</option>
                                                    <option value="14">Región XIV</option>
                                                    <option value="15">Región XV</option>
                                                    <option value="16">Región XVI</option>
                                                   </select>
                                                 </td>
                                             </tr>
                                             <tr>
                                                 <td><strong>Comuna</strong></td>
                                                 <td>
                                                 <select className="col-12 col-m-8" onChange={cambioComunaFacturacion}>
                                                     {SelectComunaFacturacion}
                                                   </select>
                                                 </td>
                                             </tr>
                                             <tr>
                                                 <td><strong>Ciudad</strong></td>
                                                 <td><span id=""><input className="col-12 col-m-8" value={stateFacturacion.ciudad} name="ciudad" onChange={CambioFacturacion}></input></span> </td>
                                             </tr>
                                             <tr>
                                                 <td><strong className="col-12 col-m-6">Numero Telefono</strong></td>
                                                 <td><span id=""><input className="col-12 col-m-8" value={stateFacturacion.telefono} name="telefono" onChange={CambioFacturacion}></input></span> </td>
                                             </tr>
                                             <tr>
                                                 <td><strong >Informacion complementaria</strong></td>
                                                 <td><span id=""><input className="col-12 col-m-8" value={stateFacturacion.complemento} name="complemento" onChange={CambioFacturacion}></input></span> </td>
                                             </tr>
                                            </tbody>
                                        </table>
                                        <div >
                                          <input type="submit" name="ctl00$ContentPlaceHolder_body$Agregar_btn" value="Actualizar dirección" id="ContentPlaceHolder_body_Agregar_btn" className="btn btn-primary" style={{backgroundColor:"#f98824",borderColor:"#f98824"}} onClick={()=>{ActualizarDatosFacturacion()}}/>
                                         
                                      </div>
                                      <br/>
                                    </div>
                                    </div>
                                </div>
		  </div>
		  </section>
		  </div>
      </div>
      </>
     :
      Mostrardo==ReferenciaDTO.UbicacionActualizarDomicilio?<>
      <div className="row" id="editar">
      <div className="col-12 col-md-6" >
              <div className="card">
              <section className="card iconos py-sm-3">
        <div className="card-body text-secondary px-sm-4" >
          <p className="subtitulo" >Actualiza tu preferencia de entrega</p>
          <div className="accordion-item">
                                    
                                    <div className="accordion-collapse collapse show" data-bs-parent="#accordionTabla">
                                    <div className="accordion-body">
                                        <table className="table table-striped table-bordered" style={{width:"100%"}} cellSpacing="0" cellPadding="0">
                                            <tbody>
                                            <tr >
                                                    <td ><strong className="col-12 col-m-8">Preferencia entrega</strong></td>
                                                    <td><select className="col-12 col-m-8"  onChange={CambioDireccion} defaultValue={Cli.lDirecciones[0].tipoDireccion}>
                                                      <option value={"DESPACHO A DOMICILIO"} >Despacho Domicilio</option>
                                                      <option value={"RETIRO SUCURSAL LAS CONDES"} >Retiro Sucursal Las Condes</option>
                                                    </select>
                                                       </td>
                                                </tr>
                                                {tipoDireccion=="DESPACHO A DOMICILIO"?
                                                <>
                                                <tr>
                                                 <td><strong>Direcciones</strong></td>
                                                 <td>
                                                   <select className="col-12 col-m-8" onChange={cambioDireccione}>
                                                      {SelectDirecciones}
                                                   </select>
                                                   </td>
                                                </tr>
                                                 <tr>
                                                 <td><strong>Calle</strong></td>
                                                 <td><span id=""><input  className="col-12 col-m-8" value={statePreferencia.calle} name="calle" onChange={cambioPreferencia}></input></span> </td>
                                             </tr>
                                             <tr>
                                                 <td><strong>Numero Calle</strong></td>
                                                 <td><span id=""><input className="col-12 col-m-8" value={statePreferencia.numero} name="numero" onChange={cambioPreferencia}></input></span> </td>
                                             </tr>
                                             <tr>
                                                 <td><strong>Region</strong></td>
                                                 <td>
                                                   <select className="col-12 col-m-8" name="region" onChange={CambioRegion}>
                                                     {SelectRegiones}
                                                   </select>
                                                 </td>
                                             </tr>
                                             <tr>
                                                 <td><strong>Comuna</strong></td>
                                                 <td>
                                                 <select className="col-12 col-m-8" onChange={CambioComuna}>
                                                     {SelectComuna}
                                                   </select>
                                                 </td>
                                             </tr>
                                             <tr>
                                                 <td><strong>Ciudad</strong></td>
                                                 <td><span id=""><input className="col-12 col-m-8" value={statePreferencia.ciudad} name="ciudad" onChange={cambioPreferencia}></input></span> </td>
                                             </tr>
                                             <tr>
                                                 <td><strong className="col-12 col-m-6">Numero Telefono</strong></td>
                                                 <td><span id=""><input className="col-12 col-m-8" value={statePreferencia.telefono} name="telefono" onChange={cambioPreferencia}></input></span> </td>
                                             </tr>
                                             <tr>
                                                 <td><strong >Informacion complementaria</strong></td>
                                                 <td><span id=""><input className="col-12 col-m-8" value={statePreferencia.complementario} name="complementario" onChange={cambioPreferencia}></input></span> </td>
                                             </tr>
                                                </>
                                                :null}
                                                
                                            </tbody>
                                        </table>
                                        <div className="row">
                                          <div className="col-sm-6">
                                            <input type="submit" name="ctl00$ContentPlaceHolder_body$" value={Cli.lDirecciones[iddireccion].direccion=="Agregar Nueva Direccion"?"Agregar Direccion":"Actualizar Dirección"}  className="btn btn-primary" style={{backgroundColor:"#f98824",borderColor:"#f98824"}} onClick={()=>ActualizarPreferencia()}/>
                                          
                                        </div>
                                       {tipoDireccion=="DESPACHO A DOMICILIO" && Cli.lDirecciones[iddireccion].direccion!="Agregar Nueva Direccion"? <div className="col-sm-6">
                                            <input type="submit" name="ctl00$ContentPlaceHolder_body$" value="Eliminar"  className="btn btn-primary"  onClick={()=>EliminarPreferencia()}/>
                                          
                                        </div>:null}
                                        </div>
                                        
                                      <br/>
                                    </div>
                                    </div>
                                </div>
		  </div>
		  </section>
              </div>
          </div>
      <div className="col-12 col-md-6" >
<div className="fondo-blanco h-100">
<div className="card">
<div className="card-body">
<h5 className="card-title"> </h5>
<div className="accordion" id="accordionFlushTabla">
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingOne">
      <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne"> Preferencias de Entrega </button>
    </h2>
    <div id="flush-collapseOne" className="accordion-collapse show" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushTabla">
      <div className="accordion-body">
        <p><strong>{Cli.lDirecciones[0]!=undefined?Cli.lDirecciones[0].tipoDireccion:""}</strong></p>
        <p><strong>Región:</strong> {Cli.lDirecciones[0]!=undefined?Cli.lDirecciones[0].region:""}<br/>
          <strong>Ciudad:</strong> {Cli.lDirecciones[0]!=undefined?Cli.lDirecciones[0].ciudad:""}<br/>
          <strong>Comuna: </strong>{Cli.lDirecciones[0]!=undefined?Cli.lDirecciones[0].comuna:""}<br/>
          <strong>Dirección: </strong>{Cli.lDirecciones[0]!=undefined?Cli.lDirecciones[0].direccion:null}<br/>
          {Cli.lDirecciones[0]!=undefined?Cli.lDirecciones[0].numero!=""?<><strong>Numero:</strong>{Cli.lDirecciones[0].numero} <br/> </> :null:null}
          {Cli.lDirecciones[0]!=undefined?Cli.lDirecciones[0].infoAdicional!=""?<><strong>Información complementaria: </strong>{Cli.lDirecciones[0].infoAdicional} </>:null:null}</p>
          <p className="small"><a href="#editar" ><i className="bi bi-pen"></i> Editar información</a></p>
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingTwo">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo"> Lugares de Retiro </button>
    </h2>
    <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushTabla">
      <div className="card-body">
        <p><strong className="color-corporativo">LAS CONDES</strong></p>
        <p>Avenida Padre Hurtado Central 1531<br/>
          <strong>Horario de atención:</strong></p>
        <p>Lunes a Viernes de 8.00 a 18.00 horario continuado </p>
        <div className="py-3">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5934.568108564439!2d-70.54630754783449!3d-33.40593299856984!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662cebde799f453%3A0xfdee4ece40a93e53!2sPadre%20Hurtado%20Central%201531%2C%20Las%20Condes%2C%20Regi%C3%B3n%20Metropolitana!5e0!3m2!1ses!2scl!4v1649690732564!5m2!1ses!2scl" style={{width:"100%",height:"250",border:0}}  loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
        </div>
        
      </div>
    </div>
  </div>
</div>
</div>
</div>
</div>
  </div>
  </div>
  </>:
Mostrardo==9?<>
<section className="section" id="calculadora">
                <div className="row" >
                    <div className="col-12 col-md-6" >
                            <div className="card">
                            <div className="card-body" >
                                <div className="card-body text-secondary px-sm-4" >
          <p className="subtitulo" >Calculadora de Compras </p>
          <div className="accordion-item">
                                    
                                    <div className="accordion-collapse collapse show" data-bs-parent="#accordionTabla">
                                   
                                    <div className="accordion-body">
                                    
            <div className="col-md-12 ">
            <div className="row">
              <div className="col-md-6">
                <input type="radio" defaultChecked id="Ebay" name="Precio" value="1" onClick={()=>{CambioCalculadora(1)}} style={{cursor:"pointer"}}>
                </input>
                <strong style={{marginRight:"10px"}}>Ebay</strong>
                <u>
                  <a id="Ebay" onClick={()=>SetCasillaCalculadora("Casilla Ebay")} style={{cursor:"pointer"}}>
                  Ver más
                  </a>
                </u>
              </div>
              <div className="col-md-6">
                <input type="radio" id="Amazon" name="Precio" value="2" onClick={()=>{CambioCalculadora(2)}} style={{cursor:"pointer"}}>
                </input>
                <strong style={{marginRight:"10px"}}>Amazon</strong>
                <u>
                  <a id="Amazon" onClick={()=>SetCasillaCalculadora("Casilla Amazon")} style={{cursor:"pointer"}}>
                  Ver más
                  </a>
                </u>
              </div>
              </div>
          </div>
       
          <div className="col-md-12 ">
            <div className="row">
              <div className="col-md-6">
                <input type="radio" id="Ebay" name="Precio" value="5" onClick={()=>{CambioCalculadora(5)}} style={{cursor:"pointer"}}>
                </input>
                <strong style={{marginRight:"10px"}}>España</strong>
                <u>
                  <a id="Espana" onClick={()=>SetCasillaCalculadora("Casilla Espana")} style={{cursor:"pointer"}}>
                  Ver más
                  </a>
                </u>
              </div>
              <div className="col-md-6">
                <input type="radio" id="Otras" name="Precio" value="0" onClick={()=>{CambioCalculadora(0)}} style={{cursor:"pointer"}}>
                </input>
                <strong style={{marginRight:"10px"}}>Otras tiendas</strong>
                <u>
                  <a id="Otras" onClick={()=>SetCasillaCalculadora("Casilla Gratis")} style={{cursor:"pointer"}}>
                  Ver más
                  </a>
                </u>
              </div>
              </div>
          </div>
          
          <div className="col-md-12 ">
            <div className="row">
             
              <div className="col-md-7">
                <input type="radio" id="Peligrosa" name="Precio" value="4" onClick={()=>{CambioCalculadora(4)}} style={{cursor:"pointer"}}>
                </input>
                <strong style={{marginRight:"10px"}}>Carga Peligrosa</strong>
                <u>
                  <a id="Peligrosa" onClick={()=>SetCasillaCalculadora("Carga peligrosa")} style={{cursor:"pointer"}}>
                  Ver más
                  </a>
                </u>
              </div>
              </div>
          </div>
              
            
          <br/>
                                        <table className="table table-striped table-bordered" style={{width:"100%"}} cellSpacing="0" cellPadding="0">
                                            <tbody>
                                                <tr>
                                                    <td><strong>Valor del Producto en US$:</strong></td>
                                                    <td><span id=""><input className="col-12 col-m-8" value={stateCaluladora.valor} type="number" name="valor" onChange={CambioCal} min={0}></input></span> </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Peso:</strong></td>
                                                    <td><span id=""><input className="col-6 col-m-6"value={stateCaluladora.peso} pattern="^[0-9]+" min={0} type="number" name="peso" onChange={CambioCal}></input><select  className="col-6 col-m-6" onChange={SelectCalPeso}>
                                                      <option value={0} >Kgs.</option>
                                                      <option value={1} >Lbs.</option>
                                                    </select></span> </td>
                                                    
                                                </tr>
                                                <tr>
                                                    <td><strong>Entrega en :</strong></td>
                                                    <td><span id=""><select onChange={SelectCalDespacho} defaultValue={-1} className="col-12 col-m-8">
                                                    <option value="-1">Retiro En Sucursal</option>
                                                    <option value="1">Región I</option>
                                                    <option value="2">Región II</option>
                                                    <option value="3">Región III</option>
                                                    <option value="4">Región IV</option>
                                                    <option value="5">Región V</option>
                                                    <option value="6">Región VI</option>
                                                    <option value="7">Región VII</option>
                                                    <option value="8">Región VIII</option>
                                                    <option value="9">Región IX</option>
                                                    <option value="10">Región X</option>
                                                    <option value="11">Región XI</option>
                                                    <option value="12">Región XII</option>
                                                    <option value="13">Región Metropolitana</option>
                                                    <option value="14">Región XIV</option>
                                                    <option value="15">Región XV</option>
                                                    <option value="16">Región XVI</option>
                                                      </select></span> </td>
                                                </tr>
                                                {stateCaluladora.despacho>-1?<tr>
                                                    <td><strong>Comuna</strong></td>
                                                    <td><span id=""><select onChange={cambioComunaCal} className="col-12 col-m-8">
                                                    {SelectComunaCalculadora}
                                                    
                                                      </select></span> </td>
                                                </tr>:null}
                                                
                                            </tbody>
                                        </table>
                                        <div >
                                          <input type="submit" name="ctl00$ContentPlaceHolder_body$Agregar_btn" value="Calcular" id="ContentPlaceHolder_body_Agregar_btn" className="btn btn-primary" style={{backgroundColor:"#f98824",borderColor:"#f98824"}} onClick={()=>Calcular()}/>
                                         
                                      </div>
                                      <br/>
                            
                                    </div>
                                    </div>
                                </div>
		  </div>
                            </div>
                            </div>
                        </div>
                    <div className="col-12 col-md-6" >
        <div className="fondo-blanco h-100">
          <div className="card">
            {DatosCalculadora.Flete==-1 || DatosCalculadora.Manejo==-1 || DatosCalculadora.domicilio==-1 || DatosCalculadora.seguro==-1 ?<div className="card-body">
              <h5 className="card-title"> </h5>
              <div className="accordion" id="accordionFlushTabla">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingOne">
                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne"> Preferencias de Entrega </button>
                  </h2>
                  <div id="flush-collapseOne" className="accordion-collapse show" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushTabla">
                    <div className="accordion-body">
                      <p><strong>{Cli.lDirecciones[0]!=undefined?Cli.lDirecciones[0].tipoDireccion:""}</strong></p>
                      <p><strong>Región:</strong> {Cli.lDirecciones[0]!=undefined?Cli.lDirecciones[0].region:""}<br/>
                        <strong>Ciudad:</strong> {Cli.lDirecciones[0]!=undefined?Cli.lDirecciones[0].ciudad:""}<br/>
                        <strong>Comuna: </strong>{Cli.lDirecciones[0]!=undefined?Cli.lDirecciones[0].comuna:""}<br/>
                        <strong>Dirección: </strong>{Cli.lDirecciones[0]!=undefined?Cli.lDirecciones[0].direccion:null}<br/>
                        {Cli.lDirecciones[0]!=undefined?Cli.lDirecciones[0].numero!=""?<><strong>Numero:</strong>{Cli.lDirecciones[0].numero} <br/> </> :null:null}
                        {Cli.lDirecciones[0]!=undefined?Cli.lDirecciones[0].infoAdicional!=""?<><strong>Información complementaria: </strong>{Cli.lDirecciones[0].infoAdicional} </>:null:null}</p>
                        <p className="small"><a href="#editar" onClick={()=>{Actualizar(ReferenciaDTO.UbicacionActualizarDomicilio)}}><i className="bi bi-pen"></i> Editar información</a></p>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingTwo">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo"> Lugares de Retiro </button>
                  </h2>
                  <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushTabla">
                    <div className="card-body">
                      <p><strong className="color-corporativo">LAS CONDES</strong></p>
                      <p>Avenida Padre Hurtado Central 1531<br/>
                        <strong>Horario de atención:</strong></p>
                      <p>Lunes a Viernes de 8.00 a 18.00 horario continuado </p>
                      <div className="py-3">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5934.568108564439!2d-70.54630754783449!3d-33.40593299856984!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662cebde799f453%3A0xfdee4ece40a93e53!2sPadre%20Hurtado%20Central%201531%2C%20Las%20Condes%2C%20Regi%C3%B3n%20Metropolitana!5e0!3m2!1ses!2scl!4v1649690732564!5m2!1ses!2scl" style={{width:"100%",height:"250",border:0}}  loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>:<>
                                <div className="card-body text-secondary px-sm-4" >
                                <p className="subtitulo" >Precio Aproximado </p>
          <div className="accordion-item">
                                    
                                    <div className="accordion-collapse collapse show" data-bs-parent="#accordionTabla">
                                   
                                    <div className="accordion-body">
                              
                                        <table className="table table-striped table-bordered" style={{width:"100%"}} cellSpacing="0" cellPadding="0">
                                            <tbody>
                                                <tr>
                                                    <td></td>
                                                    <td><strong>Precio en CLP</strong> </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Costo de Transporte:</strong></td>
                                                    <td><span id=""><strong>${formatter.format(DatosCalculadora.Flete)}</strong></span> </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Impuestos, Derechos y Otros:</strong></td>
                                                    <td><span id=""><strong>${formatter.format(DatosCalculadora.Manejo)}</strong></span> </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Seguro:</strong></td>
                                                    <td><span id=""><strong>${formatter.format(DatosCalculadora.seguro)}</strong></span> </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Despacho:</strong>
                                                    {stateCaluladora.mensaje==true?<><br/><strong style={{color:"red"}}>No se puede realizar despacho a la comuna seleccionada</strong></>:null}</td>
                                                    <td><span id=""><strong>${formatter.format(DatosCalculadora.domicilio)}</strong></span> </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Total estimado en :</strong></td>
                                                    <td><span id=""><strong>${formatter.format(DatosCalculadora.Flete+DatosCalculadora.Manejo+DatosCalculadora.seguro+DatosCalculadora.domicilio)}</strong></span> </td>
                                                </tr>
                                                
                                            </tbody>
                                        </table>
                                       
                                      <br/>
                            
                                    </div>
                                    </div>
                                </div>
		
                        </div></>}
          </div>
        </div>
                </div>
                </div>
            </section>
</>
      :Mostrardo==ReferenciaDTO.UbicacionSinFactura?<>
      <div className="row" id="Factura">
      <div className="col-sm-12">
        <section className="card iconos py-sm-3">
          <div className="card-body text-secondary px-sm-4" >
            <p className="subtitulo" >Subir Facturas</p>
            <p>
            Cuando tus productos sean enviados de forma parcializada (es decir, en varios paquetes con más de un número de tracking o rastreo), es <strong>FUNDAMENTAL</strong> que te comuniques con nuestro Servicio al Cliente una vez que lleguen a Miami, escribiendo a <a href="mailto:info@eshopex.cl">info@eshopex.cl</a> para así no pagar impuestos de más.
            </p>
            <p>
            No subas la factura por este medio (carga parcializada) ya que si no se informa correctamente este tipo de envío, los productos podrían ser declarados con valores incorrectos en Aduana, lo que puede generar un pago mayor de impuestos.
            </p>
            <p>
            Realizar este paso asegura una correcta gestión de tus paquetes y te ayuda a evitar sobrecostos innecesarios.
            </p>
            <p></p>
            {Cli.lCasilla[0].ecode!=""?<SinFacturaRastreo ></SinFacturaRastreo>:null}
        </div>
        </section>
          
        </div>
           
        </div>
        </>:
      Mostrardo==ReferenciaDTO.UbicacionCupones?
      <>
      <Cupones></Cupones>
      </>
      :
      Mostrardo==ReferenciaDTO.UbicacionDocumentacion?
      <>
      <div className="row" id="Factura">
      <div className="col-sm-12">
        <section className="card iconos py-sm-3">
          <div className="card-body text-secondary px-sm-4" >
            
            {Cli.lCasilla[0].ecode!=""?<DocumentoFaltanteAduana></DocumentoFaltanteAduana>:null}
        </div>
        </section>
          
        </div>
           
        </div> </>:
        Mostrardo==ReferenciaDTO.UbicacionVendemosContigo?
        <>
        <div className="row" id="Factura">
        <div className="col-sm-12">
          <section className="card iconos py-sm-3">
            <div className="card-body text-secondary px-sm-4" >
              <p className="subtitulo" >Formulario VendemosContigo</p>
              <p>
                  Para poder despachar a tus clientes. Debes ingresar los tipos de productos, direccion de despacho y guias asociadas  
              </p>
              
              <p></p>
              <div className="row" >
                    <div className="col-12 col-md-12" >

          <div className="card">
            
            <div className="card-body">
                      
              <div className="accordion" id="accordionAmigoRef">
                <div className="accordion-item" >
                  <h2 className="accordion-header" id="flush-AmigoOne">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseAmigoOne" aria-expanded="false" aria-controls="flush-CollapseAmigoOne"> Despachos Ya ingresados</button>
                  </h2>
                  <div id="flush-collapseAmigoOne" className="accordion-collapse collapse" aria-labelledby="flush-AmigoOne" data-bs-parent="#accordionAmigoRef">
                    <div className="accordion-body">
                    <div >
                    <div className="col-12">
        <div className="row">
        <VendemosContigoCon></VendemosContigoCon>
        </div> 

    </div>         
        
                          </div>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-AmigoTwo">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseAmigoTwo" aria-expanded="false" aria-controls="flush-CollapseAmigoTwo">Despachos Pendientes </button>
                  </h2>
                  <div id="flush-collapseAmigoTwo" className="accordion-collapse collapse" aria-labelledby="flush-AmigoTwo" data-bs-parent="#accordionAmigoRef">
                  <div className="accordion-body">
                  <div className="row">
                  <VendemosContigoSin></VendemosContigoSin>
                      </div>
                    </div>
                  </div>
                </div>          
              </div>
            </div>

        </div>
                </div>
                </div>


              
          </div>
          </section>
            
          </div>
             
          </div> </>:
          Mostrardo==ReferenciaDTO.UbicacionHistorialPuntos?
          <>
          <div className="row" id="prepago">
    <div className="col-sm-12">
      <section className="card iconos py-sm-3">
        <div className="card-body text-secondary px-sm-4" >
          {Cli.lCasilla[0].ecode!=""?<HistorialPuntos></HistorialPuntos>:null}
		  </div>
		  </section>
        
		  </div>
         
		  </div>

          </>
          :Mostrardo==ReferenciaDTO.UbicacionAmigoReferido?
          <>
          <div className="row" id="prepago">
    <div className="col-sm-12">
      <section className="card iconos py-sm-3">
        <div className="card-body text-secondary px-sm-4" >
          {Cli.lCasilla[0].ecode!=""?<HistorialAmigoReferido></HistorialAmigoReferido>:null}
		  </div>
		  </section>
        
		  </div>
         
		  </div>

      </>
      :
      null}

      
            

        <AmigoReferidos></AmigoReferidos>
        <Modelos></Modelos>
        <Calculadora></Calculadora>
        <Loading></Loading>
        <Loading2></Loading2>
        <ActivarRedireccion></ActivarRedireccion>
      </>
    )
}

export default CuentaNew;